import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';

const Title = props => {
  return (
    <Typography component="h2" variant="h6" color="primary" gutterBottom>
      {props.title}
    </Typography>
  );
};

Title.propTypes = {
  title: PropTypes.string,
};

export default Title;
